import { defineComponent as k, h as O, ref as y, inject as F, computed as z, onMounted as I, watchEffect as W, onBeforeUnmount as M, watch as N } from "vue";
import { isImageSupportNativeLazy as _ } from "./highrise1114.mjs";
import { observeIntersection as A } from "./highrise1118.mjs";
import { tagInjectionKey as V } from "./highrise502.mjs";
import { avatarGroupInjectionKey as w } from "./highrise1137.mjs";
import G from "./highrise1138.mjs";
import { resolveSlot as K, resolveWrappedSlot as D } from "./highrise1059.mjs";
import U from "./highrise1053.mjs";
import T from "./highrise984.mjs";
import { createKey as X } from "./highrise314.mjs";
import { useThemeClass as Y } from "./highrise1062.mjs";
import { color2Class as q } from "./highrise1076.mjs";
import J from "./highrise1125.mjs";
import Q from "./highrise1012.mjs";
const Z = Object.assign(Object.assign({}, T.props), {
  size: [String, Number],
  src: String,
  circle: {
    type: Boolean,
    default: void 0
  },
  objectFit: String,
  round: {
    type: Boolean,
    default: void 0
  },
  bordered: {
    type: Boolean,
    default: void 0
  },
  onError: Function,
  fallbackSrc: String,
  intersectionObserverOptions: Object,
  lazy: Boolean,
  onLoad: Function,
  renderPlaceholder: Function,
  renderFallback: Function,
  imgProps: Object,
  /** @deprecated */
  color: String
}), ve = k({
  name: "Avatar",
  props: Z,
  slots: Object,
  setup(t) {
    const {
      mergedClsPrefixRef: l,
      inlineThemeDisabled: h
    } = U(t), g = y(!1);
    let d = null;
    const c = y(null), s = y(null), L = () => {
      const {
        value: e
      } = c;
      if (e && (d === null || d !== e.innerHTML)) {
        d = e.innerHTML;
        const {
          value: r
        } = s;
        if (r) {
          const {
            offsetWidth: o,
            offsetHeight: i
          } = r, {
            offsetWidth: n,
            offsetHeight: j
          } = e, R = 0.9, x = Math.min(o / n * R, i / j * R, 1);
          e.style.transform = `translateX(-50%) translateY(-50%) scale(${x})`;
        }
      }
    }, b = F(w, null), a = z(() => {
      const {
        size: e
      } = t;
      if (e) return e;
      const {
        size: r
      } = b || {};
      return r || "medium";
    }), f = T("Avatar", "-avatar", G, Q, t, l), p = F(V, null), u = z(() => {
      if (b) return !0;
      const {
        round: e,
        circle: r
      } = t;
      return e !== void 0 || r !== void 0 ? e || r : p ? p.roundRef.value : !1;
    }), m = z(() => b ? !0 : t.bordered || !1), P = z(() => {
      const e = a.value, r = u.value, o = m.value, {
        color: i
      } = t, {
        self: {
          borderRadius: n,
          fontSize: j,
          color: R,
          border: x,
          colorModal: H,
          colorPopover: $
        },
        common: {
          cubicBezierEaseInOut: B
        }
      } = f.value;
      let E;
      return typeof e == "number" ? E = `${e}px` : E = f.value.self[X("height", e)], {
        "--n-font-size": j,
        "--n-border": o ? x : "none",
        "--n-border-radius": r ? "50%" : n,
        "--n-color": i || R,
        "--n-color-modal": i || H,
        "--n-color-popover": i || $,
        "--n-bezier": B,
        "--n-merged-size": `var(--n-avatar-size-override, ${E})`
      };
    }), v = h ? Y("avatar", z(() => {
      const e = a.value, r = u.value, o = m.value, {
        color: i
      } = t;
      let n = "";
      return e && (typeof e == "number" ? n += `a${e}` : n += e[0]), r && (n += "b"), o && (n += "c"), i && (n += q(i)), n;
    }), P, t) : void 0, S = y(!t.lazy);
    I(() => {
      if (t.lazy && t.intersectionObserverOptions) {
        let e;
        const r = W(() => {
          e == null || e(), e = void 0, t.lazy && (e = A(s.value, t.intersectionObserverOptions, S));
        });
        M(() => {
          r(), e == null || e();
        });
      }
    }), N(() => {
      var e;
      return t.src || ((e = t.imgProps) === null || e === void 0 ? void 0 : e.src);
    }, () => {
      g.value = !1;
    });
    const C = y(!t.lazy);
    return {
      textRef: c,
      selfRef: s,
      mergedRoundRef: u,
      mergedClsPrefix: l,
      fitTextTransform: L,
      cssVars: h ? void 0 : P,
      themeClass: v == null ? void 0 : v.themeClass,
      onRender: v == null ? void 0 : v.onRender,
      hasLoadError: g,
      shouldStartLoading: S,
      loaded: C,
      mergedOnError: (e) => {
        if (!S.value) return;
        g.value = !0;
        const {
          onError: r,
          imgProps: {
            onError: o
          } = {}
        } = t;
        r == null || r(e), o == null || o(e);
      },
      mergedOnLoad: (e) => {
        const {
          onLoad: r,
          imgProps: {
            onLoad: o
          } = {}
        } = t;
        r == null || r(e), o == null || o(e), C.value = !0;
      }
    };
  },
  render() {
    var t, l;
    const {
      $slots: h,
      src: g,
      mergedClsPrefix: d,
      lazy: c,
      onRender: s,
      loaded: L,
      hasLoadError: b,
      imgProps: a = {}
    } = this;
    s == null || s();
    let f;
    const p = !L && !b && (this.renderPlaceholder ? this.renderPlaceholder() : (l = (t = this.$slots).placeholder) === null || l === void 0 ? void 0 : l.call(t));
    return this.hasLoadError ? f = this.renderFallback ? this.renderFallback() : K(h.fallback, () => [O("img", {
      src: this.fallbackSrc,
      style: {
        objectFit: this.objectFit
      }
    })]) : f = D(h.default, (u) => {
      if (u)
        return O(J, {
          onResize: this.fitTextTransform
        }, {
          default: () => O("span", {
            ref: "textRef",
            class: `${d}-avatar__text`
          }, u)
        });
      if (g || a.src) {
        const m = this.src || a.src;
        return O("img", Object.assign(Object.assign({}, a), {
          loading: (
            // If interseciton observer options is set, do not use native lazy
            _ && !this.intersectionObserverOptions && c ? "lazy" : "eager"
          ),
          src: c && this.intersectionObserverOptions ? this.shouldStartLoading ? m : void 0 : m,
          "data-image-src": m,
          onLoad: this.mergedOnLoad,
          onError: this.mergedOnError,
          style: [a.style || "", {
            objectFit: this.objectFit
          }, p ? {
            height: "0",
            width: "0",
            visibility: "hidden",
            position: "absolute"
          } : ""]
        }));
      }
    }), O("span", {
      ref: "selfRef",
      class: [`${d}-avatar`, this.themeClass],
      style: this.cssVars
    }, f, c && p);
  }
});
export {
  Z as avatarProps,
  ve as default
};
